import React from 'react';
import './App.css';
import Home from './components/Home';
import { Toaster } from 'react-hot-toast';
function App() {
  return (
    <div className="app">
      <div className='relative z-0'>
        <Home />
        <Toaster
          toastOptions={{
        
            style: {
              background: 'rgba(255, 255, 255, 0.14)',
              borderRadius: '16px',
              boxShadow: '0 4px 30px rgba(0, 0, 0, 0.1)',
              backdropFilter: 'blur(5.1px)',
              color: 'white'
            },
          }} />
      </div>
    </div>
  );
}

export default App;
